import { render, staticRenderFns } from "./BrowseColumnSelectJsonProperty.vue?vue&type=template&id=a56079a8&scoped=true"
import script from "./BrowseColumnSelectJsonProperty.vue?vue&type=script&lang=ts"
export * from "./BrowseColumnSelectJsonProperty.vue?vue&type=script&lang=ts"
import style0 from "./BrowseColumnSelectJsonProperty.vue?vue&type=style&index=0&id=a56079a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a56079a8",
  null
  
)

export default component.exports